import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { FolderPlus } from 'lucide-react';

import Button from '../../../components/ui/Button';
import CandidateProfileSections, {
  SectionTitle, Rows, Label, Value,
} from '../CandidateProfileSections';
import TagChips from '../TagChips';
import AddToPoolDrawer from '../../ats-candidate-pools/components/AddToPoolDrawer';

// Genel sekmesi: çekmecedeki profil bölümlerinin AYNISI (tek kaynak) + profil ucunun
// ek alanları (kimin kaynakladığı/eklediği, etiketler, havuzlar). Havuz listesi yalnız
// AT.Write/admin'e dolu gelir (SPEC F1) — `writable` yoksa bölüm hiç çizilmez.
const Card = styled.div`
  background: ${({ theme }) => theme.colors.surface.card};
  border-radius: 6px;
  padding: 20px 24px;
  box-shadow: 0 1px 4px rgba(0, 66, 66, 0.06);
  max-width: 880px;
`;

const PoolRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

const PoolChip = styled.span`
  display: inline-flex;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => theme.colors.bgColor};
`;

const dash = (v) => (v === null || v === undefined || v === '' ? '-' : v);

export default function CandidateOverviewTab({ profile, writable, onChanged }) {
  const { t } = useTranslation();
  const [poolDrawerOpen, setPoolDrawerOpen] = useState(false);
  const pools = Array.isArray(profile?.pools) ? profile.pools : [];

  return (
    <Card data-role="candidate-overview">
      <CandidateProfileSections row={profile} />

      <SectionTitle>{t('ats.candidateProfile.originSection')}</SectionTitle>
      <Rows>
        <Label>{t('ats.candidateProfile.sourcedBy')}</Label>
        <Value>{dash(profile?.sourcedByName)}</Value>
        <Label>{t('ats.candidateProfile.submittedBy')}</Label>
        <Value>{dash(profile?.submittedByName)}</Value>
      </Rows>

      <SectionTitle>{t('ats.candidateTag.tags')}</SectionTitle>
      <TagChips tags={profile?.tags} empty={t('ats.candidateTag.noTags')} />

      {writable && (
        <>
          <SectionTitle>{t('ats.candidatePool.pools')}</SectionTitle>
          <PoolRow data-role="candidate-pools">
            {pools.length === 0 && <Value as="span">{t('ats.candidatePool.notInAnyPool')}</Value>}
            {pools.map((p) => <PoolChip key={p.id}>{p.name}</PoolChip>)}
            <Button
              type="button"
              variant="outline"
              data-role="candidate-add-to-pool"
              onClick={() => setPoolDrawerOpen(true)}
            >
              <FolderPlus size={14} />
              {t('ats.candidatePool.addToPool')}
            </Button>
          </PoolRow>
          <AddToPoolDrawer
            open={poolDrawerOpen}
            onClose={() => setPoolDrawerOpen(false)}
            candidateIds={profile?.id ? [profile.id] : []}
            onAdded={() => { if (onChanged) onChanged(); }}
          />
        </>
      )}
    </Card>
  );
}
